import * as angular from 'angular';

import { DateRange } from '../../models';
import { IUserService } from './';
import { IAuthenticationService, IWorkspaceService } from '../general';

export interface IUserSettingsService {
    addSelectedDate(beginDate: string, endDate: string): angular.IPromise<any>;
    getSettingValue(key: string): string;
    getTypedSettingValue<T>(key: string): T;
    setSettingValue(key: string, value: string);
    setTypedSettingValue<T>(key: string, value: T);
    getApplicationSetting<T>(key: string): T;
    setApplicationSetting<T>(key: string, value: T);
}

export class UserSettingsService implements IUserSettingsService {
    static serviceId = 'userSettingsService';

    validity: Date;

    static $inject = ['authenticationService', 'userService', 'localStorageService', 'workspaceService'];

    constructor(
        private _authenticationService: IAuthenticationService,
        private _userService: IUserService,
        private _localStorageService: angular.local.storage.ILocalStorageService,
        private _workspaceService: IWorkspaceService
    ) {

        const now = new Date();
        this.validity = new Date(now.getFullYear(), now.getMonth() + 6, now.getDate());
    }

    addSelectedDate(beginDate: string, endDate: string): angular.IPromise<any> {
        const range = new DateRange();
        range.beginDateTime = beginDate;
        range.endDateTime = endDate;
        const userName = this._authenticationService.authentication.userName;
        return this._userService.addSelecteddDatesForUser(userName, range);
    }

    getApplicationSetting<T>(key: string): T {
        const workspace = this._workspaceService.getWorkspace();
        const actualKey = `${JSON.stringify(workspace)}-${key}`;
        return this._localStorageService.get(actualKey);
    }

    setApplicationSetting<T>(key: string, value: T) {
        const workspace = this._workspaceService.getWorkspace();
        const actualKey = `${JSON.stringify(workspace)}-${key}`;
        this._localStorageService.set(actualKey, value);
    }

    getSettingValue(key: string): string {
        return this._localStorageService.get(key);
    }

    getTypedSettingValue<T>(key: string): T {
        return this._localStorageService.get(key);
    }

    setSettingValue(key: string, value: string) {
        this._localStorageService.set(key, value);
    }

    setTypedSettingValue<T>(key: string, value: T) {
        this._localStorageService.set(key, value);
    }
}
